import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { filter, map, Observable } from 'rxjs';
import { ConfigurationService } from './configuration.service';
import { DriftConfiguration } from '../models/configuration.interface';
import { Log } from '../models/prompt-log.interface';

@Injectable({
  providedIn: 'root'
})
export class S3Service {
  config: DriftConfiguration;

  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService
  ) {
    this.config = {};

    this.configurationService
      .configurationLoaded()
      .pipe(filter(loaded => loaded === true))
      .subscribe(() => {
        this.config = this.configurationService.getConfiguration();
      });
  }

  getFiles(type: string, collection_id: string): Observable<Log[]> {
    const params = new HttpParams().set('collection_id', collection_id).set('type', type);
    return this.http.get<Log[]>(`${this.config.driftApi}/logs`, { params });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pollResult(filename: string): Observable<any> {
    const requestBody = { filename };
    return this.http.post(`${this.config.driftApi}/poll-result`, requestBody, {
      observe: 'response'
    });
  }

  /**
   * Get a presigned URL for an S3 object, given its docUri and pageNumber.
   * @param docUri The S3 URI of the document (e.g., s3://bucket/key)
   * @param pageNumber The page number to reference (if applicable)
   * @returns Observable<string> - The presigned URL as a string
   */
  getPresignedUrl(docUri: string, pageNumber: number): Observable<string> {
    const params = new HttpParams().set('doc_uri', docUri).set('page_number', pageNumber.toString());
    return this.http.get<{ url: string }>(`${this.config.driftApi}/presigned-url-citations`, { params }).pipe(
      filter(response => !!response.url),
      // Map to just the URL string
      map(response => response.url)
    );
  }
}
